import React, { Component, Fragment } from 'react';
import { Card, CardBody } from 'reactstrap';

import ResponseBlockGenerator from '../components/ResponseBlockGenerator';
import { gAPI_About_Property } from '../../../../../constants/APIs';

export default class AboutProperty extends Component {
  render() {
    return (
      <Fragment>
        <Card>
          <CardBody>
            <ResponseBlockGenerator getUrl={gAPI_About_Property} />
          </CardBody>
        </Card>
      </Fragment>
    );
  }
}
